export default __webpack_public_path__ + "static/media/4.f25e717b.jpg";